import { request } from '../config/axios-utils';

export const getOrganizations = async () => {
    const { data } = await request({ url: '/organizations', method: 'get' });

    return data;
};

export const getOrganizationMetadata = async ({ queryKey }) => {
    const idOrganization = queryKey[2];
    const { data } = await request({
        url: `/users/current-organization/${idOrganization}`,
        method: 'post'
    });
    return data.metadata;
};
